<template>
  <div id="app">
    <div id="long-size">
      <div id="nav" style="position: relative;">
        <router-link to="/">
          <img alt="Logo de Green Solutions" src="@/assets/LOGO-GREEN.png" width="" style="position: absolute; left: 7%; top: 1%; width: 12vw;" />
        </router-link>
         <md-speed-dial class="md-top-center" style="left: 44%; top: 33%" md-effect="scale" md-direction="bottom">
           
          <md-speed-dial-target>
          
            <div>
             <span style="display: inline! important ;font-weight: bold !important; color: #707070 !important;">
               Sellos Sustentables 
             </span>
             <span style="display: inline! important; color: transparent;">
               Sellos Sustentables saaa
             </span>
             
            <md-icon class="md-morph-initial">
              <img alt="Flecha hacia abajo" src="@/assets/flecha-hacia-abajo.svg" width="12vw"  srcset="">
            </md-icon>
            <md-icon class="md-morph-final">
              <img alt="Cancelar" src="@/assets/cancelar.svg" width="9vw"  srcset="">
            </md-icon>
            </div>
           
            
          </md-speed-dial-target>

          <md-speed-dial-content class="sellos-sustentables">
            <md-button  @click="navigation('huelladecarbono')" >Huella de Carbono </md-button>

            <md-button @click="navigation('huelladeagua')" >Huella del agua</md-button>

            <md-button  @click="navigation('carbonoNeutral')">Carbono Neutral </md-button>

            <md-button  @click="navigation('huellaChile')" v-if="weAreInCl">HuellaChile </md-button>

            <md-button  @click="navigation('energiarenovable')" v-if="weAreInCl"> Energía Renovable</md-button>
           
          </md-speed-dial-content>

        </md-speed-dial>
       
          
          <a href="https://blog.greensolutions.cl" style="padding-right:7%;">Blog</a>
          <a href="/#clients">Nuestros clientes</a> 
        
        <button class="btn-green pulse"  @click="showDialog"  >
          <img alt="Calendario" src="@/assets/date.svg"  srcset="" width='20px' style="margin-right: 5px; margin-top: -4px" />
          AGENDA UNA REUNIÓN
          <md-tooltip md-direction="left">Agenda un reunión con un ejecutivo</md-tooltip>  
        </button>
        
      </div>
      <main>
          <transition name="slide-fade"  mode="out-in">
            <router-view />
          </transition>
            <Footer />
          
      </main>
    </div>

    <div class="page-container" id="phone-size">
      
    
      <md-app md-mode="reveal">
        <md-app-toolbar class="md-green-success ">
          <span class="md-title">
            <router-link to="/">
              <img alt="Logo de Green Solutions" src="@/assets/LOGO-GREEN.png" width="180" style="" />
            </router-link>
          </span>
          
          <div class="md-toolbar-section-end">
            <md-speed-dial class="md-top-right" md-direction="bottom" md-event="click" id="speed-dial" style="width: 39%;" >
              <md-speed-dial-target >
                <md-icon class="md-morph-initial">
                  <img alt="Menu" src="@/assets/menu.svg"   srcset="">
                </md-icon>
                <md-icon class="md-morph-final">
                  <img alt="Cerrar" src="@/assets/cerrar.svg" width="20px"  srcset="">
                </md-icon>
              </md-speed-dial-target>

              <md-speed-dial-content class="phone-view-menu">
                <md-button  class="phone-view-button" @click="navigation('huelladecarbono')" >Huella de Carbono </md-button>

                <md-button class="phone-view-button" @click="navigation('huelladeagua')" >Huella del agua</md-button>
            
                <md-button class="phone-view-button" @click="navigation('carbonoNeutral')">Carbono Neutral </md-button>

                <md-button class="phone-view-button" @click="navigation('huellaChile')" v-if="weAreInCl">HuellaChile </md-button>

                <md-button  class="phone-view-button" @click="navigation('energiarenovable')" v-if="weAreInCl">Energía Renovable</md-button>

                <md-button class="phone-view-button" @click="navigation('#how')"  >Blog</md-button>

                <md-button  class="phone-view-button md-success" style="width: 230% !important" @click="showDialog" >
                  <img alt="Calendario" src="@/assets/date.svg"  srcset="" width='20px' style="margin-right: 5px; margin-top: -4px" />
                  AGENDA UNA REUNIÓN
                </md-button>

              </md-speed-dial-content>
            </md-speed-dial>
          </div>  
        </md-app-toolbar>
        <md-app-content>
          <transition name="slide-fade"  mode="out-in">
            <router-view />
          </transition>
          <Footer />
        </md-app-content>
      </md-app>
    </div>
    <div>
        <md-dialog-confirm
          :md-active.sync="$store.state.showDialog"
          md-content='<iframe src="https://calendly.com/didier-gs/hdc" frameborder="0" style="width:100%; height:100%"></iframe>'
          md-confirm-text="Ok"
          @md-confirm="onConfirm" />
      </div>

     
   
  </div>
</template>

<script>
import VueRouter from 'vue-router'
import Footer from './components/Footer'
export default {
  components: {Footer},
  data () {
    return {
      menuVisible: false,
      weAreInCl: true
    }
  },

  created() {
    if (window.location.origin === 'http://greensolutions.com.ar' || window.location.origin === 'https://greensolutions.com.ar'){
      this.weAreInCl = false
    }
  },
  methods: {
    navigation (route) { 
      if (route === '#how') {
        window.open('https://blog.greensolutions.cl', '_self').focus();
        //this.$router.push({path: `/${route}` })
        //window.scrollBy(0, 1220); 
      }
      this.$router.push({path: `/${route}` })
      var speed = document.getElementById('speed-dial')  
      speed.classList.toggle('md-active')
    },
    onConfirm () {
      this.$store.state.showDialog = false
    },
    showDialog () {
      this.$store.state.showDialog = true
      //return gtag_report_conversion('http://localhost:8080/')
      gtag( 'event', 'Click',{
          event_category: 'Agendar',
          event_label: 'calendly',
          value: 0
      })
    }
  }
}
</script>

<style>
div.md-toolbar-section-end .md-button.md-theme-default.md-fab:not([disabled]) > div.md-ripple {
  justify-content: flex-end !important;
  padding-right: 2rem !important;
  height: 100% !important;
}


.phone-view-button {
  border-bottom: solid 1px #a5a3a3;
  width: 220%;
  margin-right: 110% !important;
  height: 50px !important;
  margin-top: 0px !important;
  margin-bottom: 0px !important;
  text-align: justify !important;
  padding-left: 0 !important;
  font-weight: bold !important;
  color: #707070 !important;
}
.sellos-sustentables button{
  border-bottom: solid 1px #a5a3a3;
  width: 110% !important;
  height: 50px !important;
  margin-top: 0px !important;
  margin-bottom: 0px !important;
  text-align: justify !important;
  padding-left: 0 !important;
  font-weight: bold !important;
  color: #707070 !important;
  box-shadow: none !important;
}
.sellos-sustentables div.md-ripple {
  justify-content: flex-start;
}
.md-button.md-theme-default.md-fab:not([disabled]) {
  background-color: #ffffff !important;
  box-shadow: none !important;
  border-radius: 0 !important;
}
.md-button.md-theme-default.md-fab:not([disabled]) > div.md-ripple {
  justify-content: start !important;
}
.md-fab .md-ripple, .md-fab:before, .md-icon-button .md-ripple, .md-icon-button:before {
    border-radius: 0 !important;
}
.md-fab {
  box-shadow: none !important;
  width: 12vw !important;
  height: 30px !important;
  border-radius: 0 !important;
}
.menu-top {
    position: absolute !important;
    top: 28% !important;
    left: 25% !important;
}
.menu-top .md-button-content {
  font-weight: bold !important;
  color: #707070 !important;
}
div.md-list-item-content > a {
  font-weight: bold !important;
  color: #707070 !important;
}
.patty {
  height: 4px;
  width: 30px;
  margin-top: 6px;
  margin-bottom: 6px;
  border-top-left-radius: 8px;
  border-bottom-right-radius: 8px;
  background-color: #707070;
}
.md-elevation-4 {
  box-shadow: #ffffff !important;
}
.md-green-success {
  background-color: #ffffff !important;
  color: #ffffff !important;
  box-shadow: 0 2px 4px -1px rgba(250, 250, 250, 0.2),0 4px 5px 0 rgba(255, 255, 255, 0.14),0 1px 10px 0 rgba(255, 255, 255, 0.12) !important;
}

.md-app-content {
  padding: 0% !important;
}
.pulse:hover, 
.pulse:focus {
  box-shadow: 0 0.5em 0.5em -0.4em var(--hover);
  transform: translateY(-0.55em);
}
@keyframes pulse {
  0% { box-shadow: 0 0 0 2 var(--hover); }
}
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #707070;
  overflow-y: hidden;
}
main {
  overflow-y: hidden;
}

#nav {
  padding: 30px;
  margin-top: 1rem;
  text-align: right;
}

#navTwo  a {
  font-weight: bold;
  color: #707070;
}


#nav  a {
  font-weight: bold;
  color: #707070;
  padding: 2vw;
  font-size: 1vw;
}

.btn-green {
  cursor: pointer;
  width: 17vw;
  height: 3vw;
  margin-top: -0.5rem;
  margin-left: 2rem;
  border-radius: 30px;
  -webkit-box-shadow: 5px 3px 17px -4px rgba(148,143,148,1);
  -moz-box-shadow: 5px 3px 17px -4px rgba(148,143,148,1);
  box-shadow: 5px 3px 17px -4px rgba(148,143,148,1);
  background-color: #707070;
  color: #ffffff;
  font-weight: bold;
  float: right; 
  position: relative; 
  top: -25%;
  right: 0;
  border: #eeeeee;
  transition: 0.55s;
  font-size: 1vw;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .4s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.slide-fade-enter-active {
  transition: all .5s ease;
}
.slide-fade-leave-active {
  transition: all .5s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
.modal {
  width: 90vw !important;
  height: 100vh !;
}
.md-dialog-container.md-theme-default {
  width: 100vw;
  height: 100vh;
  background-color: #ffffff !important;
}
</style>
